import useSyncedLocalStorage from "@avinet/adaptive-ui-core/hooks/useSyncedLocalStorage";
import { SESSION_TOKEN_KEY } from "../config/config";

function useSessionToken(): string | null {
  const [sessionToken] = useSyncedLocalStorage(SESSION_TOKEN_KEY);
  return sessionToken;
}

export default useSessionToken;
